"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ResearchElementDefinition_Characteristic = exports.ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind = exports.ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Expression_1 = require("./RTTI_Expression");
var RTTI_DataRequirement_1 = require("./RTTI_DataRequirement");
var RTTI_UsageContext_1 = require("./RTTI_UsageContext");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Duration_1 = require("./RTTI_Duration");
var RTTI_Timing_1 = require("./RTTI_Timing");
var ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind;
(function (ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind) {
    ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind["_mean"] = "mean";
    ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind["_median"] = "median";
    ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind["_meanOfMean"] = "mean-of-mean";
    ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind["_meanOfMedian"] = "mean-of-median";
    ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind["_medianOfMean"] = "median-of-mean";
    ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind["_medianOfMedian"] = "median-of-median";
})(ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind = exports.ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind || (exports.ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind = {}));
var ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind;
(function (ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind) {
    ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind["_mean"] = "mean";
    ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind["_median"] = "median";
    ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind["_meanOfMean"] = "mean-of-mean";
    ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind["_meanOfMedian"] = "mean-of-median";
    ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind["_medianOfMean"] = "median-of-mean";
    ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind["_medianOfMedian"] = "median-of-median";
})(ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind = exports.ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind || (exports.ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_ResearchElementDefinition_Characteristic = t.recursion('IResearchElementDefinition_Characteristic', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        definitionCodeableConcept: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        definitionCanonical: t.string,
        _definitionCanonical: RTTI_Element_1.RTTI_Element,
        definitionExpression: RTTI_Expression_1.RTTI_Expression,
        definitionDataRequirement: RTTI_DataRequirement_1.RTTI_DataRequirement,
        usageContext: t.array(RTTI_UsageContext_1.RTTI_UsageContext),
        exclude: t.boolean,
        _exclude: RTTI_Element_1.RTTI_Element,
        unitOfMeasure: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        studyEffectiveDescription: t.string,
        _studyEffectiveDescription: RTTI_Element_1.RTTI_Element,
        studyEffectiveDateTime: t.string,
        _studyEffectiveDateTime: RTTI_Element_1.RTTI_Element,
        studyEffectivePeriod: RTTI_Period_1.RTTI_Period,
        studyEffectiveDuration: RTTI_Duration_1.RTTI_Duration,
        studyEffectiveTiming: RTTI_Timing_1.RTTI_Timing,
        studyEffectiveTimeFromStart: RTTI_Duration_1.RTTI_Duration,
        studyEffectiveGroupMeasure: (0, EnumType_1.createEnumType)(ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind, 'ResearchElementDefinition_CharacteristicStudyEffectiveGroupMeasureKind'),
        _studyEffectiveGroupMeasure: RTTI_Element_1.RTTI_Element,
        participantEffectiveDescription: t.string,
        _participantEffectiveDescription: RTTI_Element_1.RTTI_Element,
        participantEffectiveDateTime: t.string,
        _participantEffectiveDateTime: RTTI_Element_1.RTTI_Element,
        participantEffectivePeriod: RTTI_Period_1.RTTI_Period,
        participantEffectiveDuration: RTTI_Duration_1.RTTI_Duration,
        participantEffectiveTiming: RTTI_Timing_1.RTTI_Timing,
        participantEffectiveTimeFromStart: RTTI_Duration_1.RTTI_Duration,
        participantEffectiveGroupMeasure: (0, EnumType_1.createEnumType)(ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind, 'ResearchElementDefinition_CharacteristicParticipantEffectiveGroupMeasureKind'),
        _participantEffectiveGroupMeasure: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_ResearchElementDefinition_Characteristic.js.map